<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column" 
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
    <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      :class="{'visible':visibleMenu}"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
        <PCGuideSearch />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <PCGuideTable />
        <main class="" id="main">
          <FontawesomeIcon v-if="state.loading" :icon="['fal','spinner-third']" size="2x" class="loading icn fa-spin" />
          <div v-else class="box02 white">
            <div class="box02-hdg">
              <h1 class="box02-hdg-title hdg01">{{guide.detail.title}}</h1>
            </div>
            <div class="box02-body" id="scroll-target"
              style="height:calc(100vh - 120px);"
              @scroll="handleScroll"
              >
              <div id="cms-content-area">
                <div class="box02-body-detail" v-html="guide.detail.detail"></div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCGuideTable from '@/components/pc/partial/guide/PCGuideTable.vue'
import PCGuideSearch from '@/components/pc/partial/guide/PCGuideSearch.vue'

import { GuideDetail} from '@/logic/guide/GuideDetail'

export default defineComponent({
  props: {
    guideId: {
      default: null
    }
  },
  components: {
    PCMenu,
    PCGuideTable,
    PCGuideSearch
  },  
  setup (props, context) {
    return { 
      ...GuideDetail(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}
#content {
  display: flex;
  flex-wrap: nowrap;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
}
.box02-body {
  overflow: auto;
  .date {
    color: #ccc;
    padding: 48px 40px 0;
  }
}
.navi-func-link {
  font-size: 1.2rem;
  color: $color-sup;
  margin: 30px 92px 20px 24px;
  .text {
    text-decoration: underline;
  }
  .text + .text {
    padding-left: 20px;
    margin-left: 20px;
    border-left: 1px solid $color-line;
  }
}

.navi-title {
  padding: 0 20px;
  margin-top: 10px;
  margin-bottom: 8px;
  color: $color-hdg;
  font-size: 2.0rem;
  font-weight: bold;
}

.navi-back {
    padding: 0 20px;
    margin-top: 0px;
    margin-bottom: 15px;
    font-size: 1.6rem;
}
#navi {
  position: relative;
  padding: 0;
  background-color: transparent;
  border-radius: 8px 0 0 8px;
  width: 25%;
  margin-top: 0;
  left: 0;
  border-right: 1px solid $color-line;
  transition: width .2s ease;
  &.is-fullsize {
    width: 100%;
    border-right: 0;
  }
}
#cms-content-area ::v-deep {
  .box02-body-detail {
    padding: 0px 60px 40px 40px;
    h2 {
      color: #3b4557;
      font-weight: 700;
      margin: 80px 0 32px;
      font-size: 2.4rem;
    }
    h3 {
      color: #3b4557;
      font-weight: 700;
      margin: 32px 0 24px;
      font-size: 1.8rem;
    }
    h4 {
      color: #3b4557;
      font-weight: 700;
      margin: 24px 0 24px;
      font-size: 1.6rem;
    }
    h5 {
      color: #3b4557;
      font-weight: 700;
      margin: 24px 0 24px;
      font-size: 1.4rem;
    }
    p {
      margin: 24px 0 24px;
      font-size: 1.4rem;
      color: #555;
      &-sup {
        margin: 24px 0 24px;
        font-size: 1.2rem;
        color: #999999 !important;
      }
    }
    div.wae-section-margin-moderate {
      font-size: 1.4rem;
      color: #555;
    }
    .wae-section-note p {
      font-size: 1.2rem;
      color: #999!important;
    }
    table {
      border-collapse:collapse;
      td {
        padding: 2px 6px;
      }
    }

    ul:not(.wae-section-list-number) {
      padding-left: 24px;
      margin: 32px 0;
      li {
        color: #555555;
        font-size: 1.4rem;
        position: relative;
      }
      li:before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background-color: #555;
        border-radius: 2px;
        position: absolute;
        top: 6px;
        left: -20px;
      }
    }

    ul.wae-section-list-number {
      padding-left: 24px;
      margin: 32px 0;
      counter-reset: number;
      list-style: none;
      li {
        color: #555555;
        font-size: 1.4rem;
        position: relative;
      }
      li:before {
        counter-increment: number;
        content: "("counter(number)")";
        position: absolute;
        top: 0px;
        left: -26px;
        color: #555555;
        font-size: 1.4rem;
      }
    }
    img {
      margin: 32px 0;
      display: block;
      margin: 0 auto;
      width: 100%;
    }
    a {
      color: #005bac!important;
    }
    hr {
      border-top: 0;
      border-bottom: 1px solid #DDDDDD;
      margin: 10px 0;
    }
  }
}
</style>
